/* ── Đã xem gần đây ──────────────────────────────────────────────────────────
   Ghi handle vào localStorage mỗi lần mở một trang sản phẩm, rồi dựng lại thành
   một hàng thẻ.

   Chỉ lưu HANDLE, cùng lý do với danh sách quà: giá và ảnh đổi theo thời gian
   nên bản sao trong máy khách sẽ sai dần, còn handle đủ để hỏi lại Shopify.

   Khác danh sách quà ở một điểm quan trọng: đây là thứ khách KHÔNG chủ động
   tạo ra. Vì vậy có nút xoá, và giới hạn cứng 12 món — một danh sách tự mọc mà
   không có trần thì sớm muộn thành một cái đuôi dài vô nghĩa.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var KHOA = 'cg:recent';
  var TRAN = 12;

  function doc() {
    try {
      var raw = window.localStorage.getItem(KHOA);
      var ds = raw ? JSON.parse(raw) : [];
      return Array.isArray(ds) ? ds.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) {
      return [];
    }
  }

  function ghi(ds) {
    try { window.localStorage.setItem(KHOA, JSON.stringify(ds.slice(0, TRAN))); } catch (e) {}
  }

  var khung = document.querySelector('[data-cg-recent]');
  var hienTai = khung ? khung.getAttribute('data-current-handle') : null;

  /* Ghi TRƯỚC khi dựng, nhưng dựng thì loại món hiện tại ra. Ghi trước để lần
     sau quay lại vẫn thấy nó; loại ra để hàng này không lặp đúng thứ đang mở. */
  if (hienTai) {
    var ds = doc().filter(function (h) { return h !== hienTai; });
    ds.unshift(hienTai);
    ghi(ds);
  }

  if (!khung) return;

  var luoi = khung.querySelector('[data-cg-recent-grid]');
  var gioiHan = Number(khung.getAttribute('data-limit')) || 6;
  var canDung = doc().filter(function (h) { return h !== hienTai; }).slice(0, gioiHan);

  if (!canDung.length) return; /* khung vẫn hidden */

  Promise.all(
    canDung.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })
  ).then(function (sp) {
    var con = sp.filter(Boolean);
    if (!con.length) return;

    con.forEach(function (p) {
      var anh = p.featured_image || (p.images && p.images[0]) || '';
      var li = document.createElement('li');
      li.className = 'cg-recent__item';
      li.innerHTML =
        '<a class="cg-recent__link" href="/products/' + p.handle + '">' +
        (anh ? '<img class="cg-recent__image" src="' + anh + '&width=420" alt="" loading="lazy" width="210" height="210">' : '') +
        '<span class="cg-recent__title"></span>' +
        '<span class="cg-recent__price"></span>' +
        '</a>';
      /* textContent chứ không nhét vào chuỗi HTML: tên sản phẩm do người nhập. */
      li.querySelector('.cg-recent__title').textContent = p.title;
      li.querySelector('.cg-recent__price').textContent = (p.price / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
      });
      luoi.appendChild(li);
    });

    khung.hidden = false;
  });

  khung.addEventListener('click', function (event) {
    if (!event.target.closest('[data-cg-recent-clear]')) return;
    try { window.localStorage.removeItem(KHOA); } catch (e) {}
    khung.hidden = true;
  });
})();
